// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".newTitle[data-v-945c06b4]:hover{color:#409eff}.number[data-v-945c06b4]{font-weight:700;color:#9498a6}.num1[data-v-945c06b4]{color:#fe4b60}.num2[data-v-945c06b4]{color:#f60}.num3[data-v-945c06b4]{color:#faab13}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
